import {useTranslation} from "react-i18next";
import labelsDefault from "./labelsDefault";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DateDisplay from "components/datetime/DateDisplay";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableProgramming = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const getStatus = (item) => {
        let templates = [];
        if (item.is_periodic) {
            templates.push(<FontAwesomeIcon icon="check" className="text-secondary me-2" />);
        } else {
            templates.push(<FontAwesomeIcon icon="xmark" className="text-secondary me-2" />);
        }
        return templates.map((el, idx) => <span key={idx}>{el}</span>);
    };

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.length ? (
                    itemsShow.map((item) => {
                        return (
                            <tr key={item.id} data-idx={item.id} onClick={onClick}>
                                <td>
                                    <input
                                        type="checkbox"
                                        name="checkboxContainer"
                                        key={item.id}
                                        data-idx={item.id}
                                        defaultChecked={items.current.chosen.includes(item.id)}
                                        readOnly={true}
                                    />
                                </td>
                                <td>{item.name}</td>
                                <td>{_Tc(`reports.${item.report_type}`) || item.report_type}</td>
                                <td>{_Tc(`repeat.${item.repeat}`) || item.repeat}</td>
                                <td>
                                    <DateDisplay date={item.date_start} format="DD-MM-YYYY" title={true} />
                                </td>
                                <td>{item.run || "-"}</td>
                                <td>
                                    {item.email_recipients?.length > 0
                                        ? `${item.email_recipients.length} destinatario(s)`
                                        : "Sin destinatarios"}
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableProgramming;
